import WidgetType from "./WidgetType";

class WidgetTypeClass {
  constructor(private readonly _value: WidgetType = WidgetType.NONE) {
  }

  public static of(value: string): WidgetTypeClass {
    switch (value) {
      default:
        return new WidgetTypeClass();
      case WidgetType.TEXT_BOX:
        return new WidgetTypeClass(WidgetType.TEXT_BOX);
      case WidgetType.TEXT_AREA_SMALL:
        return new WidgetTypeClass(WidgetType.TEXT_AREA_SMALL);
      case WidgetType.TEXT_AREA_MEDIUM:
        return new WidgetTypeClass(WidgetType.TEXT_AREA_MEDIUM);
      case WidgetType.TEXT_AREA_LARGE:
        return new WidgetTypeClass(WidgetType.TEXT_AREA_LARGE);
      case WidgetType.RADIO_VERTICAL:
        return new WidgetTypeClass(WidgetType.RADIO_VERTICAL);
      case WidgetType.RADIO_HORIZONTAL:
        return new WidgetTypeClass(WidgetType.RADIO_HORIZONTAL);
      case WidgetType.CHECK_VERTICAL:
        return new WidgetTypeClass(WidgetType.CHECK_VERTICAL);
      case WidgetType.CHECK_HORIZONTAL:
        return new WidgetTypeClass(WidgetType.CHECK_HORIZONTAL);
      case WidgetType.IMAGE_SMALL:
        return new WidgetTypeClass(WidgetType.IMAGE_SMALL);
      case WidgetType.IMAGE_MEDIUM:
        return new WidgetTypeClass(WidgetType.IMAGE_MEDIUM);
      case WidgetType.IMAGE_LARGE:
        return new WidgetTypeClass(WidgetType.IMAGE_LARGE);
      case WidgetType.IMAGE_A4:
        return new WidgetTypeClass(WidgetType.IMAGE_A4);
    }
  }

  get value() {
    return this._value;
  }
}

export default WidgetTypeClass;
